<template>
  <div>
    <v-card flat>
      <div class="mt-10 d-flex justify-space-between heading-2">
        Courses Taken
        <v-btn
          rounded
          outlined
          color="#1884CD"
          class=""
          @click="openAddCourseModal()"
          dark
          style="text-transform: none !important; border: 1px solid #d2e5fc"
          >Add Course</v-btn
        >
      </div>

      <div>
        <v-card class="mt-6" outlined>
          <v-data-table
            :headers="couresheaders"
            :items="GetEnrolledCourseOrSeminarByUserId"
            :loading="btnloader"
            loading-text="Loading... Please wait"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`item.SeminarDateAndTime`]="{ item }">
              <span class="index_span_2_style">
                {{ item.SeminarDateAndTime[0]?.Date?.split("T")[0]?.replaceAll("-", "/") }} - 
                {{ item.SeminarDateAndTime[item.SeminarDateAndTime?.length - 1]?.Date?.split("T")[0]?.replaceAll("-", "/") }}
              </span>
            </template>
            <template v-slot:[`item.Course`]="{ item }">
              <span class="index_span_2_style">
                {{ item.Course.CourseTitle }}
              </span>
            </template>
            <template v-slot:[`item.Monitor`]="{ item }">
              <span class="index_span_2_style">
                {{ item.Monitor ? 'Yes' : "No" }}
              </span>
            </template>
            <template v-slot:[`item.UserGraduationDate`]="{ item }">
              <span class="index_span_2_style">
                {{ item.UserGraduationDate && item.UserGraduationDate.split("T")[0].replaceAll("-", "/") }}
              </span>
            </template>
            <template v-slot:[`item.UserGraduationDateMonitor`]="{ item }">
              <span class="index_span_2_style">
                {{ item.UserGraduationDate ? 'Yes' : "No" }}
              </span>
            </template>

            <template v-slot:[`item.actionss`]="{ item }">
              <v-icon color="#A1A1A6" class="pa-4" @click="openDeleteDialog(item.Id)"> mdi-delete </v-icon>
              <v-dialog v-if="deletedialog" v-model="deletedialog" persistent max-width="390">
                <v-card class="px-1 pt-1 pb-2">
                  <v-card-title class="text-h5 pb-0 mb-1">Warning</v-card-title>
                  <v-card-text class="index_span_2_style" style="font-size: 18px;"
                    >Are you sure you want to delete?</v-card-text
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="closeDeleteDialog">
                      Cancel
                    </v-btn>
                    <v-btn
                      color="primary"
                      :disabled="btnloader"
                      @click="deleteEnrollCousre"
                    >
                      <span v-if="btnloader != true">Confirm</span>
                      <v-progress-circular
                        indeterminate
                        v-else
                        size="20"
                        class="px-5"
                        color="white"
                        v-show="btnloader"
                      ></v-progress-circular>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn depressed outlined color="primary" class="pa-4" v-if="!item.UserGraduationDate" @click="graduateStudents(item)">
                Graduate
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-card>
    <!-------------AddCourseDialog----------------------------->
    <v-dialog v-model="AddCourseDialog" width="1100" persistent>
      <v-card v-if="AddCourseDialog" class="pa-9">
        <div class="d-flex align-center justify-space-between">
          <h4>Add Course</h4>
          <v-icon @click="closeAddCourse">mdi-close</v-icon>
        </div>
        <div class="my-2 d-flex align-center justify-center">
          <h5>User:</h5>
          <h5 class="primary--text mx-3"><b> {{GetPreviewUser.FirstName}} {{GetPreviewUser.LastName}}</b></h5>
        </div>
        <div>
          <v-row>
            <v-col cols="12" md="6" class="d-flex align-center">
              <v-row no-gutters>
                <v-col cols="3" align-self="center"> Instructor:</v-col>
                <v-col cols="9">
                  <v-autocomplete
                    attach
                    :items="GetAllInstructorsIDsAndNames"
                    v-model="form.InstructorId"
                    item-text="Name"
                              item-value="Id"
                    placeholder="Select Intructor"
                    :error-messages="
                      $v.form.InstructorId.$error
                        ? 'Instructor is required'
                        : null
                    "
                  ></v-autocomplete
                ></v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6" class="d-flex align-center">
              <v-row no-gutters>
                <v-col cols="3" align-self="center"> Course: </v-col>
                <v-col cols="9">
                  <v-autocomplete
                    placeholder="Select Course"
                    attach
                    :items="ActiveCourses"
                    v-model="form.CourseId"
                    item-text="Title"
                    item-value="Id"
                    :error-messages="
                      $v.form.CourseId.$error ? 'Course is required' : null
                    "
                  ></v-autocomplete
                ></v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="d-flex align-center">
              <v-row no-gutters>
                <v-col cols="3" align-self="center"> Month/Year:</v-col>
                <v-col cols="9">
                  <v-menu
                    attach
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :return-value.sync="form.Date"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.Date"
                        append-icon="mdi-calendar"
                        readonly
                        outlined
                        single-line
                        v-bind="attrs"
                        dense
                        v-on="on"
                        ></v-text-field>
                        <!-- :error-messages="
                          $v.form.Date.$error ? 'Date is required' : null
                        " -->
                    </template>
                    <v-date-picker
                      v-model="form.Date"
                      type="month"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu1 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu1.save(form.Date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <div class="d-flex justify-end">
            <v-btn color="primary" class="mt-9 mb-3 px-9" 
              :disabled="btnloader" 
              @click="showSeminar()"
            >
              <span v-if="btnloader != true">Show Seminars</span>
              <v-progress-circular
                indeterminate
                v-else
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
            </v-btn>
          </div>
        </div>
        <table class="w-100 mt-9">
          <tr>
            <th style="width: 30%">
              <div class="d-flex justify-center py-2">
                Start Date - End Date
              </div>
            </th>
            <th style="width: 20%">
              <div class="d-flex justify-center py-2">Location</div>
            </th>
            <th style="width: 15%">
              <div class="d-flex justify-center py-2">Course(s)</div>
            </th>
            <th style="width: 15%">
              <div class="d-flex justify-center py-2">Instructor</div>
            </th>
            <th style="width: 15%">
              <div class="d-flex justify-center py-2">Select</div>
            </th>
          </tr>
          <tbody>
            <tr v-for="(item,index) in getSeminars" :key="index">
              <td style="width: 30%">
                <div class="d-flex justify-center py-2">
                  {{
                    item.SeminarDateAndTime
                      ? item.SeminarDateAndTime[0]?.StartTime?.split("T")[0]
                      : ""
                  }}
                  <br />
                  {{
                    item.SeminarDateAndTime
                      ? item.SeminarDateAndTime[0]?.EndTime?.split("T")[0]
                      : ""
                  }}
                </div>
              </td>
              <td style="width: 20%">
                <div class="d-flex justify-center py-2">
                  {{ item.Location?.LocationName }}
                </div>
              </td>
              <td style="width: 15%">
                <div class="d-flex justify-center py-2">
                  {{ item?.CourseName }}
                </div>
              </td>
              <td style="width: 15%">
                <div class="d-flex justify-center py-2">
                  {{ item?.InstructorName }}
                </div>
              </td>
              <td style="width: 15%">
                <div class="d-flex justify-center py-2">
                  <v-radio-group v-model="RadioSelectedCourse">
                    <v-radio :value="item.SeminarId"></v-radio>
                  </v-radio-group>
                </div>
              </td>
            </tr>
          </tbody>
          <!-- <tr>
            <td>
              <div class="d-flex justify-center py-2">Self-Study Course</div>
            </td>
            <td>
              <div class="d-flex justify-center py-2">Eastern Medicine</div>
            </td>
            <td><div class="d-flex justify-center py-2"></div></td>
            <td><div class="d-flex justify-center py-2">1</div></td>
            <td><div class="d-flex justify-center py-2">$ 300.00</div></td>
          </tr> -->
        </table>
        <v-row class="mt-9">
          <v-col cols="12" md="6" class="d-flex align-center">
            <b> Graduate student: </b>
            <div class="ml-4 mt-1">
              <v-switch v-model="GraduateStudentToogle" :disabled="isGraduateToggleDisabled"></v-switch>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="d-flex align-center" v-if="GraduateStudentToogle">
            <b> Graduate Date: </b>
            <div class="ml-4 mt-1">
              <v-menu
                ref="menu"
                v-model="GraduateDate"
                :close-on-content-click="false"
                :return-value.sync="graduateDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="graduateDate"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    single-line
                    v-bind="attrs"
                    dense
                    v-on="on"
                    :error-messages="
                      $v.graduateDate.$error ? 'Graduate date is required' : null
                    "
                  ></v-text-field>
                </template>
                <v-date-picker :max="calculateMaximumDate" v-model="graduateDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="GraduateDate = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(graduateDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>
        </v-row>

        <div class="d-flex justify-center my-4">
          <v-btn color="primary" class="px-11" @click="AddNewCourse"
            >Add Course</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default {
  mixins: [validationMixin],
  components: {},
  validations: {
    form: {
      InstructorId: {
        required,
      },
      CourseId: {
        required,
      },
      Date: {
        // required,
      },
    },
    graduateDate: {
      required,
    },
  },
  computed: {
    ...mapGetters([
      "GetPreviewUser",
      "GetCoursesTaken",
      "GetEnrolledCourseOrSeminarByUserId",
      "GetAllInstructorsIDsAndNames",
      "GetInstructors",
      "GetCourses",
      "GetSeminarByInstructorIdAndCourseId",
      "GetLoggedInUser",
      "GetCoursesIDsAndTitle"
    ]),
    isGraduateToggleDisabled() {
      const selectedSeminarId = this.RadioSelectedCourse;
      const selectedSeminar = this.getSeminars.find(seminar => seminar.SeminarId === selectedSeminarId);

      if (selectedSeminar) {
        const seminarStartTime = new Date(selectedSeminar.SeminarDateAndTime[0]?.StartTime);
        return seminarStartTime > new Date();
      }
      return false;
    },
    ActiveCourses() {
      return this.$store.getters.GetActiveCoursesList;
    },
    calculateMaximumDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
  mounted() {
    const obj= {
      page: 1,
      pageSize: "all",
    }
    this.$store.dispatch("GetActiveCoursesList", obj)
    this.fetchData()
    if (this.GetPreviewUser == null) {
      this.$router.push("/users");
    }

    // this.fetchCourses();
  },

  name: "seeprofilecomponent",
  data() {
    return {
      deletedialog: false,
      selectedCourseId: null,
      getSeminars:[],
      btnloader: false,
      form: {
        InstructorId: null,
        CourseId: null,
        Date: "",
      },
      GraduateStudentToogle: false,
      GraduateDate: false,
      date: new Date().toISOString().substr(0, 7),
      dateComplete: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      graduateDate: "",
      menu1: false,
      RadioSelectedCourse: null,
      AddCourseDialog: false,
      couresheaders: [
        { text: "Date", value: "SeminarDateAndTime", },
        { text: "Course", value: "Course", },
        { text: "Graduate", value: "UserGraduationDateMonitor", },
        { text: "Instructor", value: "InstructorName",  },
        { text: "Monitor", value: "Monitor",  },
        { text: "Graduation Date", value: "UserGraduationDate",  },
        // { text: "How to Registered", value: "register", sortable: false },
        { text: "", value: "actions", sortable: false },
        { text: "", value: "actionss", sortable: false  },
      ],
      courseDataTable: [
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "",
          instructor: "John veltheim",
          monitor: "Yes",
          hregisterdate: "16/12/2021",
          register: "Website",
        },
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "",
          instructor: "John veltheim",
          monitor: "No",
          hregisterdate: "16/12/2021",
          register: "Instructor",
        },
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "11/02/2017",
          instructor: "John veltheim",
          monitor: "Yes",
          hregisterdate: "16/12/2021",
          register: "Admin",
        },
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "11/02/2017",
          instructor: "John veltheim",
          monitor: "No",
          hregisterdate: "16/12/2021",
          register: "PaRama Campus",
        },
      ],
      CEUheaders: [
        { text: "Date", value: "date", sortable: false },
        { text: "Course", value: "course", sortable: false },
        { text: "Graduate", value: "graduate", sortable: false },
        { text: "Instructor", value: "instructor", sortable: false },
        { text: "Monitor", value: "monitor", sortable: false },
        { text: "Register Date", value: "registerdate", sortable: false },
        { text: "How Registered", value: "register", sortable: false },
        { text: "", value: "actions", sortable: false },
        { text: "", value: "actionss", sortable: false },
      ],

      tabs: null,
    };
  },
  methods: {
    graduateStudents(item){
      console.log(item)
      const obj = {
        SeminarId: item.SeminarId,
        StudentIds: [this.GetPreviewUser.Id],
      };
      const seminarDate = new Date(item.SeminarDateAndTime[0]?.StartTime);
      const currentDate = new Date();

      // Check if the seminar date has occurred
      if (seminarDate > currentDate) {
        this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Cannot graduate courses in future",
            showConfirmButton: false,
            timer: 2500,
          });
        return;
      }
      this.$store.dispatch("GraduateStudents", obj).then(() => {
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Graduate Student successfully",
          showConfirmButton: false,
          timer: 3000,
        });
        this.fetchData();
      });
    },
    openDeleteDialog(courseId) {
      this.selectedCourseId = courseId;
      this.deletedialog = false; // Ensure reset before opening
      this.$nextTick(() => {
        this.deletedialog = true;
      });
    },
    closeDeleteDialog() {
      this.deletedialog = false;
      this.selectedCourseId = null; // Reset selected course
      this.$nextTick(() => {
        this.deletedialog = false; // Ensure it's fully closed
      });
    },
    deleteEnrollCousre(){
      if (!this.selectedCourseId) return;
      this.btnloader = true;
      this.$store.dispatch("DeleteEnrolledCourseOrSeminarById", this.selectedCourseId).then(()=>{
        this.closeDeleteDialog();
        this.btnloader = false;
        this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "Course has been deleted successfully",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
        this.fetchData()
      });
    },
    fetchData(){
      const obj = {
      id: this.GetPreviewUser.Id,
    };
    this.btnloader=true;
    this.$store.dispatch("GetEnrolledCourseOrSeminarByUserId", obj).then(()=>{
      this.btnloader=false;
});
    },
    openAddCourseModal(){
      this.getSeminars = [];
      
      this.$store.dispatch("GetAllInstructorsIDsAndNames")
      this.AddCourseDialog = true
    },
    showSeminar() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      } else{
        this.btnloader=true;
        this.$store
        .dispatch("GetSeminarByInstructorIdAndCourseId", this.form)
        .then(() => {
          this.getSeminars = this.GetSeminarByInstructorIdAndCourseId
          this.btnloader=false;
        });
      }
    },
    async fetchCourses() {
      const obj = {
        page: 1,
        pageSize: "all",
        search: "",
        filters: "",
      };
      await this.$store.dispatch("GetCourse", obj);
    },
    AddNewCourse() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      if (this.GraduateStudentToogle) {
        this.$v.graduateDate.$touch();
        if (this.$v.graduateDate.$invalid) {
          return;
        }
      }
      const obj = {
        SeminarId: this.RadioSelectedCourse,
        UserId: this.GetPreviewUser.Id,
        CreatedBy: this.GetLoggedInUser.Id,
        IsGraduated: this.GraduateStudentToogle,
        GraduationDate: this.graduateDate,
      };
      if(this.RadioSelectedCourse == null){
        this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "Select Seminar First",
          showConfirmButton: false,
          timer: 1500,
          toast: true,
        });
        return;
      }
      this.$store.dispatch("EnrollCourseOrSeminarWithoutPayment",obj).then((response)=>{
        if (response.Status) {
          this.fetchData()
          this.closeAddCourse();
          this.$swal.fire({
            icon: "success",
            title: "Course has been added successfully",
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: response.Message || "Something went wrong.",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      })
    },
    close() {
      this.editdialog = false;
      this.editexam = false;
      this.addreseditdialog = false;
      this.add_dialog = false;
      this.snackbar = true;
    },
    closeAddCourse(){
      this.AddCourseDialog = false;
      this.form.InstructorId = null
      this.form.CourseId = null
      this.form.Date = ""
      this.graduateDate = ""
      this.$v.$reset()
    },
    closeDialog() {
      this.add_dialog = false;
      this.value = false;
    },
    DdialogClose() {
      this.dialog = false;
      this.Deletesnackbar = true;
    },
    snackbarClose() {
      // this.snackbar = false;
      this.Deletesnackbar = false;
    },
    openadddialog() {
      this.add_dialog = true;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.add_dialog = false;
        this.editdialog = false;
        this.editexam = false;
        this.addreseditdialog = false;
        this.addreseditdialog = false;
        this.Membereditdialog = false;
        this.billingeditdialog = false;
        this.Memberinfoeditdialog = false;
        this.editAddressdialog = false;
        this.btnloader = false;
      }, 2000);
    },
  },
};
</script>

<style scoped>
table,
td,
th {
  border: 1px solid;
}
th {
  background-color: #cccccc;
}
</style>
